import React, { Component } from 'react'
import qs from 'qs'
import PropTypes from 'prop-types'
import { assetPrefix } from '../../stv.config'
import styles from './styles'
import { Spinner } from '..'
import { UPDATE_LIVE_PLAYER_PROPS, FEATURE_LIVE_SCRUB_SKIP_BUTTON } from '../../constants'
import { trackEvent } from '../../utils/dtmHelpers'

class LivePlayer extends Component {
  constructor(props) {
    super(props)
    this.state.queryString = this.buildQueryString()
  }

  state = {
    queryString: '',
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  componentDidUpdate = (prevProps) => {
    // Some props should trigger the player iframe to re-render because the stream URL has changed
    let rerender = false
    const rerenderKeys = ['isRestartStream', 'streamUrl']
    if (FEATURE_LIVE_SCRUB_SKIP_BUTTON) rerenderKeys.push('isScrubStream')
    rerenderKeys.forEach((key) => {
      if (this.props[key] !== prevProps[key]) rerender = true
    })
    if (rerender) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ queryString: this.buildQueryString() })
    } else {
      // these settings get passed to the player which updates itself without a re-render
      const updateKeys = ['poster', 'restartEnabled', 'matId']
      if (FEATURE_LIVE_SCRUB_SKIP_BUTTON) updateKeys.push('scrubEnabled')
      const newData = {}
      let updated = false
      updateKeys.forEach((key) => {
        if (this.props[key] !== prevProps[key]) {
          trackEvent('liveProgranmeChange', {})
          updated = true
          newData[key] = this.props[key]
          newData.channel = this.props?.channel
          newData.programmeName = this.props?.programmeName
          newData.streamUrl = decodeURIComponent(this.props?.streamUrl)
          newData.stream = this.props?.stream
          newData.startTime = this.props?.startTime
        }
      })

      if (updated) this.updateIframe(newData)
    }
  }

  buildQueryString = () => (qs.stringify(
    {
      channel: this.props.channel,
      guid: this.props.guid,
      title: this.props.channelTitle,
      region: this.props.region,
      stream: this.props.stream,
      streamUrl: this.props.streamUrl,
      isRestartStream: this.props.isRestartStream,
      isScrubStream: this.props.isScrubStream,
      restartEnabled: this.props.restartEnabled,
      poster: this.props.poster,
      programmeTitle: this.props?.title,
      startTime: this.props.startTime,
      videoId: this.props.videoId,
      endTime: this.props.endTime,
      programmeName: this.props.programmeName,
      programmeGuid: this.props.programmeGuid,
      matId: this.props.matId,
      scrubEnabled: this.props?.scrubEnabled,
    },
    // filter out values which are null, undefined or empty strings,
    // but keep values which are explicitly false.
    {
      filter: (k, v) => ((
        typeof v === 'undefined'
        || v === ''
        || v === null)
        ? undefined : v), // eslint-disable-line no-undefined
    }
  ))

  updateIframe = (newData) => {
    window.postMessage({
      type: UPDATE_LIVE_PLAYER_PROPS,
      newData,
    }, '*')
  }

  render = () => (
    <div className="LivePlayer">
      {!this.props.loginChecked && (
        <div className="await-check-div">
          <Spinner />
        </div>
      )}
      {this.props.loginChecked && (
        <iframe
          allowFullScreen
          title="STV Live Player"
          className="LivePlayer-frame"
          src={`${assetPrefix}/players/live?${this.state.queryString}`}
        />
      )}
      <style jsx>{styles}</style>
    </div>
  )
}

LivePlayer.propTypes = {
  channel: PropTypes.string.isRequired,
  guid: PropTypes.string.isRequired,
  region: PropTypes.string,
  stream: PropTypes.string.isRequired,
  streamUrl: PropTypes.string.isRequired,
  isRestartStream: PropTypes.bool.isRequired,
  isScrubStream: PropTypes.bool,
  restartEnabled: PropTypes.bool.isRequired,
  scrubEnabled: PropTypes.bool,
  loginChecked: PropTypes.bool.isRequired,
  poster: PropTypes.string,
  title: PropTypes.string,
  programmeName: PropTypes.string.isRequired,
  programmeGuid: PropTypes.string.isRequired,
  videoId: PropTypes.string,
  startTime: PropTypes.string,
  endTime: PropTypes.string,
  matId: PropTypes.string,
  channelTitle: PropTypes.string,
}

LivePlayer.defaultProps = {
  poster: null,
  region: null,
  startTime: null,
  endTime: null,
  matId: null,
  title: null,
  scrubEnabled: false,
  isScrubStream: false,
  videoId: null,
  channelTitle: null,
}

export default LivePlayer
